<template>
  <YaTeTerms />
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import YaTeTerms from '~/components/YaTe/YaTeTerms/YaTeTerms.vue'

const options = {
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title: 'LINEヤフーテックアカデミー利用規約 | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description: 'LINEヤフーテックアカデミーの利用規約',
            twitterTitle:
              'LINEヤフーテックアカデミー利用規約 | テックアカデミー',
            twitterDescription: 'LINEヤフーテックアカデミーの利用規約',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogDescription: 'LINEヤフーテックアカデミーの利用規約',
            ogTitle: 'LINEヤフーテックアカデミー利用規約 | テックアカデミー',
            ogUrl: '/yahoo/terms',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTeTerms,
  },
  async setup() {
    definePageMeta({
      layout: 'yate-side-menu'
    })
  },
}

export default defineNuxtComponent(options)
</script>
